import { useGetSocialInsights } from "../../../api/leadsManagement"
import { usePermissionStore } from "../../../stores/permissionStore";

const useSocialInsights = () => {
    const { data, isLoading, isError } = useGetSocialInsights({
        permission_Token: usePermissionStore.getState().permissionToken ?? ""
    });

    const socialInsightsData = data?.data

    return {
        socialInsightsData,
        isLoading,
        isError

    }
}

export default useSocialInsights;